import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
import { UtilsService } from 'core/utils/utils.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'app-error-list',
  templateUrl: './error-list.component.html',
  styleUrls: ['./error-list.component.scss'],
  standalone: false
})
export class ErrorListComponent implements OnInit {
  appStrings: AppLocalization;
  errorListResult = {
    countErrors: '',
    errors: []
  };
  pageSize = 50;
  currentPage = 0;

  constructor(
    private appInfoService: AppInfoService,
    private dashboardService: DashboardService,
    private notificationService: NotificationService,
    private utilsService: UtilsService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.getErrorList(0);
  }

  loadPage(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.getErrorList(event.pageIndex);
  }

  getErrorList(pageIndex) {
    const offsetPage = pageIndex * this.pageSize;
    this.dashboardService.getErrorList(pageIndex, offsetPage, errorsList => {
      this.errorListResult.countErrors = errorsList.count;
      this.errorListResult.errors = errorsList.errors;
    });
  }

  copyErrorListToClipboard() {
    const jsonToCopy = JSON.stringify(this.errorListResult.errors, null, 1);
    this.utilsService.copyTextToClipboard(jsonToCopy);
    this.notificationService.showNotification(this.appStrings.errorList_clipboardNotification, NotificationType.Warning, false, true);
  }
}
